import React from 'react';
import YouTubeIcon from 'components/svg/livestream/youtube.svg';
import FacebookLive from 'components/svg/livestream/fb_live.svg';
import ZoomIcon from 'components/svg/livestream/zoom.svg';
import Airplay from 'components/svg/livestream/airplay.svg';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const defaultIcon = <SettingsOutlinedIcon />;

const iconsByVirtualPlatforms = {
  custom: <Airplay />,
  facebook_live: <FacebookLive />,
  zoom: <ZoomIcon />,
  youtube: <YouTubeIcon />,
};

export const getIconByVirtualPlatform = (platform) => {
  const icon = iconsByVirtualPlatforms[platform];
  if (icon) return icon;
  return defaultIcon;
};
